import { useMemo } from "react";
import { AccountingReportCycleOptionType } from "@common/constants";
import { DateRange } from "@common/helpers/date";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { useLedgers } from "@api/ledger.api";
import { ReportComparisonOptions } from "@components/reports/reportDisplayFilters";
import { findPrimaryLedgerId } from "@lib/accountOverrides";

export interface CashLedgerReportParams {
    entityId: number | undefined;
    dateRange: Partial<DateRange>;
    cycle: AccountingReportCycleOptionType;
    comparisonOptions: ReportComparisonOptions;
}

export const useCashLedgerReportFilters = ({
    entityId,
    dateRange,
    cycle,
    comparisonOptions,
}: CashLedgerReportParams) => {
    const ledgersQuery = useLedgers(entityId);
    const ledgerId = useMemo(
        () =>
            findPrimaryLedgerId(ledgersQuery.data, AccountingLedgerBasis.cash),
        [ledgersQuery.data],
    );

    const filters = useMemo(
        () => ({
            startDate: dateRange.start,
            endDate: dateRange.end,
            cycle,
            entityId,
            ledgerId,
            comparisons: comparisonOptions.comparisons,
            comparisonDiffs: comparisonOptions.comparisonDiffs,
            ratioTypes: comparisonOptions.ratioTypes,
        }),
        [dateRange, cycle, entityId, ledgerId, comparisonOptions],
    );

    return { ledgerId, ledgersQuery, filters };
};
